<template>
  <div class="documentsMainWrapper">
    <DocumentsList
      :code="store.model?.contrat?.codeDrf!"
      :dispositif="store.model!.dispositif!"
      endpoint="reservationsfonds"
      :pieces="store.model?.pieces!"
      :statut="store.model?.statut!"
      :natures-authorisees="store.model?.naturesPiecesDeposables"
    />
    <CourriersList
      :courriers="store.model?.courriers ?? []"
      :code="store.model?.contrat?.codeDrf!"
      endpoint="reservationsfonds"
    />
  </div>
</template>

<script setup lang="ts">
  import { DEMANDE_STORE } from '@/features/interface/demande/shared/components'
  import CourriersList from '@/features/interface/detail/components/CourriersList.vue'
  import DocumentsList from '@/features/interface/detail/components/DocumentsList.vue'
  import { inject } from 'vue'

  const store = inject(DEMANDE_STORE)!.getStore<'MODEL_CXPI'>()
</script>

<style scoped lang="less">
  @import './DocumentsDossierStep.less';
  .documents {
    display: flex;
    flex-direction: column;
    gap: @spacing-25;
    height: 100vh;

    &__section {
      display: flex;
      flex-direction: column;
      gap: @spacing-15;

      &__button {
        width: 500px;
      }
    }
  }
</style>
